import { useDensity } from '../../../hooks/useDensity';

// Density-switch — Kompakt / Normal / Komfort. Drives the body class
// `density-*` via useDensity, which flips --row-h + --pad-x in
// src/index.css.
//
// Icons are the inline SVG glyphs from the handoff prototype
// (icons.jsx:68-78) rather than lucide stand-ins — three stacked
// lines whose spacing visually telegraphs the row-height bump.

function DensityIcon({ density }) {
  const common = {
    width: 12, height: 12, viewBox: '0 0 24 24', fill: 'none',
    stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round',
    'aria-hidden': true,
  };
  if (density === 'compact') return <svg {...common}><path d="M4 7h16M4 12h16M4 17h16" /></svg>;
  if (density === 'comfy')   return <svg {...common}><path d="M4 5h16M4 19h16" /></svg>;
  return <svg {...common}><path d="M4 6h16M4 12h16M4 18h16" /></svg>;
}

const OPTS = [
  { id: 'compact', label: 'Kompakt' },
  { id: 'default', label: 'Normal'  },
  { id: 'comfy',   label: 'Komfort' },
];

export default function DensitySwitch() {
  const [density, setDensity] = useDensity();
  return (
    <div
      role="group"
      aria-label="Tabellen-Dichte"
      title="Tabellen-Dichte"
      className="inline-flex bg-surface border border-line"
      style={{ borderRadius: 'var(--radius-md)', padding: 2 }}
    >
      {OPTS.map((o) => {
        const active = density === o.id;
        return (
          <button
            key={o.id}
            type="button"
            tabIndex={-1}
            onClick={() => setDensity(o.id)}
            aria-pressed={active}
            title={`Dichte: ${o.label}`}
            className={`inline-flex items-center gap-1 text-[11px] ${
              active ? 'bg-page text-brand font-semibold' : 'text-ink-3 font-medium'
            }`}
            style={{ height: 24, padding: '0 8px', border: 'none', borderRadius: 6, cursor: 'pointer' }}
          >
            <DensityIcon density={o.id} />
            <span>{o.label}</span>
          </button>
        );
      })}
    </div>
  );
}
